import { configureStore } from "@reduxjs/toolkit";

import company from "./companySlice";
import currentUser from "./currentUserSlice";
import documents from "./documentsSlice";
import hints from "./hintsSlice";
import notifications from "./notificationsSlice";
import projects from "./projectsSlice";
import tasks from "./tasksSlice";
import talentPool from "./talentPoolSlice";
import ui from "./uiSlice";
import whitepaper from "./whitepaperSlice";

export default configureStore({
  reducer: {
    company,
    currentUser,
    documents,
    hints,
    notifications,
    projects,
    tasks,
    talentPool,
    ui,
    whitepaper,
  },
});
